export default __webpack_public_path__ + "static/hodler_mobile-15fb993871c35bf9da971708afe2b9c7.png";